import PreviewAssessmentButton from "pages/PanelPage/components/PreviewAssessmentButton/PreviewAssessmentButton";

export default PreviewAssessmentButton;
